(function () {
    'use strict';

    angular
        .module('recomActionPlanUpdateStatusControllers')
        .controller('ActionPlanUpdateStatusController', Controller);

    Controller.$inject = ['$state', '$stateParams', 'topBarService', 'activeProcess'];

    function Controller($state, $stateParams, topBarService, activeProcess) {
        topBarService.setTitleAndIcon('Action Plan Progress Tracking', 'fa fa-road');

        var isGovProcDisabled = !_.isObject(activeProcess) || _.isUndefined(activeProcess.GovernanceProcessID);
        if ($state.is('actionPlanUpdateStatusWelcome')) {
            if (!isGovProcDisabled) {
                $state.go('actionPlanUpdateStatusOwnerList', { BusinessUnitCode: $stateParams.BusinessUnitCode }, { location: 'replace' });
            }
            
            return;
        }

        if (!$state.is('actionPlanUpdateStatusWelcome') && isGovProcDisabled) {
            $state.go('actionPlanUpdateStatusWelcome', { BusinessUnitCode: $stateParams.BusinessUnitCode }, { location: 'replace' });
        }
    }
})();